import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getWpHelpPath } from '@/app/common/api/config';

const wpHelpApi = createApi({
  reducerPath: 'wpHelpApi',
  baseQuery: (...args) => customFetchBase(getWpHelpPath(), ...args),
  endpoints: build => ({
    getPostBySlug: build.query<unknown, string>({
      query: data => ({
        url: `posts?slug=${data}`,
        method: 'get'
      })
    })
  })
});

export const { useLazyGetPostBySlugQuery } = wpHelpApi;

export default wpHelpApi;
